export default __webpack_public_path__ + "static/media/reviewPic1.6b956388.svg";